import { render } from "./LocationList.vue?vue&type=template&id=1b7bb99a&ts=true"
import script from "./LocationList.vue?vue&type=script&lang=ts"
export * from "./LocationList.vue?vue&type=script&lang=ts"

import "./LocationList.vue?vue&type=style&index=0&id=1b7bb99a&lang=css"

import exportComponent from "/home/steffen/IdeaProjects/Antara/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__